var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JtMenu',{staticClass:"menu overflow-hidden",attrs:{"links":_vm.computedItems,"config":_vm.menuConfig},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }